//# sourceMappingURL=metrics.mjs.map
/// <reference types="./metrics.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $order from "../../gleam_stdlib/gleam/order.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $duration from "../../gleam_time/gleam/time/duration.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $uuid from "../../tiamat/crypto/uuid.mjs";
import * as $duration_ from "../../tiamat/gleam/time/duration_.mjs";
import * as $timestamp_ from "../../tiamat/gleam/time/timestamp_.mjs";
import * as $decrypt from "../decrypt.mjs";
import { Ok, toList, CustomType as $CustomType, makeError, remainderInt } from "../gleam.mjs";

const FILEPATH = "src/data/metrics.gleam";

export class MetricsCurve extends $CustomType {
  constructor(curve, metrics) {
    super();
    this.curve = curve;
    this.metrics = metrics;
  }
}
export const MetricsCurve$MetricsCurve = (curve, metrics) =>
  new MetricsCurve(curve, metrics);
export const MetricsCurve$isMetricsCurve = (value) =>
  value instanceof MetricsCurve;
export const MetricsCurve$MetricsCurve$curve = (value) => value.curve;
export const MetricsCurve$MetricsCurve$0 = (value) => value.curve;
export const MetricsCurve$MetricsCurve$metrics = (value) => value.metrics;
export const MetricsCurve$MetricsCurve$1 = (value) => value.metrics;

export class Metric extends $CustomType {
  constructor(id, value, curve_id, created_at) {
    super();
    this.id = id;
    this.value = value;
    this.curve_id = curve_id;
    this.created_at = created_at;
  }
}
export const Metric$Metric = (id, value, curve_id, created_at) =>
  new Metric(id, value, curve_id, created_at);
export const Metric$isMetric = (value) => value instanceof Metric;
export const Metric$Metric$id = (value) => value.id;
export const Metric$Metric$0 = (value) => value.id;
export const Metric$Metric$value = (value) => value.value;
export const Metric$Metric$1 = (value) => value.value;
export const Metric$Metric$curve_id = (value) => value.curve_id;
export const Metric$Metric$2 = (value) => value.curve_id;
export const Metric$Metric$created_at = (value) => value.created_at;
export const Metric$Metric$3 = (value) => value.created_at;

export class QuestionCreated extends $CustomType {}
export const CurveKind$QuestionCreated = () => new QuestionCreated();
export const CurveKind$isQuestionCreated = (value) =>
  value instanceof QuestionCreated;

export class AnswerCreated extends $CustomType {}
export const CurveKind$AnswerCreated = () => new AnswerCreated();
export const CurveKind$isAnswerCreated = (value) =>
  value instanceof AnswerCreated;

export class AnswerValidated extends $CustomType {}
export const CurveKind$AnswerValidated = () => new AnswerValidated();
export const CurveKind$isAnswerValidated = (value) =>
  value instanceof AnswerValidated;

export class ProposalCreated extends $CustomType {}
export const CurveKind$ProposalCreated = () => new ProposalCreated();
export const CurveKind$isProposalCreated = (value) =>
  value instanceof ProposalCreated;

export class ConfidenceScore extends $CustomType {}
export const CurveKind$ConfidenceScore = () => new ConfidenceScore();
export const CurveKind$isConfidenceScore = (value) =>
  value instanceof ConfidenceScore;

export class Unknown extends $CustomType {}
export const CurveKind$Unknown = () => new Unknown();
export const CurveKind$isUnknown = (value) => value instanceof Unknown;

export class TranslationPerLangCreated extends $CustomType {}
export const MetricGroupKind$TranslationPerLangCreated = () =>
  new TranslationPerLangCreated();
export const MetricGroupKind$isTranslationPerLangCreated = (value) =>
  value instanceof TranslationPerLangCreated;

export class ProposalLanguagePerOrg extends $CustomType {}
export const MetricGroupKind$ProposalLanguagePerOrg = () =>
  new ProposalLanguagePerOrg();
export const MetricGroupKind$isProposalLanguagePerOrg = (value) =>
  value instanceof ProposalLanguagePerOrg;

export class ProposalDefaultLanguagePerOrg extends $CustomType {}
export const MetricGroupKind$ProposalDefaultLanguagePerOrg = () =>
  new ProposalDefaultLanguagePerOrg();
export const MetricGroupKind$isProposalDefaultLanguagePerOrg = (value) =>
  value instanceof ProposalDefaultLanguagePerOrg;

export class UnknownGroup extends $CustomType {}
export const MetricGroupKind$UnknownGroup = () => new UnknownGroup();
export const MetricGroupKind$isUnknownGroup = (value) =>
  value instanceof UnknownGroup;

export class CurveData extends $CustomType {
  constructor(name, period, kind) {
    super();
    this.name = name;
    this.period = period;
    this.kind = kind;
  }
}
export const CurveData$CurveData = (name, period, kind) =>
  new CurveData(name, period, kind);
export const CurveData$isCurveData = (value) => value instanceof CurveData;
export const CurveData$CurveData$name = (value) => value.name;
export const CurveData$CurveData$0 = (value) => value.name;
export const CurveData$CurveData$period = (value) => value.period;
export const CurveData$CurveData$1 = (value) => value.period;
export const CurveData$CurveData$kind = (value) => value.kind;
export const CurveData$CurveData$2 = (value) => value.kind;

export class Curve extends $CustomType {
  constructor(id, org_id, created_at, data) {
    super();
    this.id = id;
    this.org_id = org_id;
    this.created_at = created_at;
    this.data = data;
  }
}
export const Curve$Curve = (id, org_id, created_at, data) =>
  new Curve(id, org_id, created_at, data);
export const Curve$isCurve = (value) => value instanceof Curve;
export const Curve$Curve$id = (value) => value.id;
export const Curve$Curve$0 = (value) => value.id;
export const Curve$Curve$org_id = (value) => value.org_id;
export const Curve$Curve$1 = (value) => value.org_id;
export const Curve$Curve$created_at = (value) => value.created_at;
export const Curve$Curve$2 = (value) => value.created_at;
export const Curve$Curve$data = (value) => value.data;
export const Curve$Curve$3 = (value) => value.data;

export class InstantMetric extends $CustomType {
  constructor(value, label, group_label) {
    super();
    this.value = value;
    this.label = label;
    this.group_label = group_label;
  }
}
export const InstantMetric$InstantMetric = (value, label, group_label) =>
  new InstantMetric(value, label, group_label);
export const InstantMetric$isInstantMetric = (value) =>
  value instanceof InstantMetric;
export const InstantMetric$InstantMetric$value = (value) => value.value;
export const InstantMetric$InstantMetric$0 = (value) => value.value;
export const InstantMetric$InstantMetric$label = (value) => value.label;
export const InstantMetric$InstantMetric$1 = (value) => value.label;
export const InstantMetric$InstantMetric$group_label = (value) =>
  value.group_label;
export const InstantMetric$InstantMetric$2 = (value) => value.group_label;

export class MetricGroup extends $CustomType {
  constructor(kind, data) {
    super();
    this.kind = kind;
    this.data = data;
  }
}
export const MetricGroup$MetricGroup = (kind, data) =>
  new MetricGroup(kind, data);
export const MetricGroup$isMetricGroup = (value) =>
  value instanceof MetricGroup;
export const MetricGroup$MetricGroup$kind = (value) => value.kind;
export const MetricGroup$MetricGroup$0 = (value) => value.kind;
export const MetricGroup$MetricGroup$data = (value) => value.data;
export const MetricGroup$MetricGroup$1 = (value) => value.data;

function metric_group_kind_decoder() {
  return $decode.then$(
    $decode.string,
    (kind) => {
      if (kind === "proposal_language_org") {
        return $decode.success(new ProposalLanguagePerOrg());
      } else if (kind === "translation_lang_created") {
        return $decode.success(new TranslationPerLangCreated());
      } else if (kind === "translation_default_lang_created") {
        return $decode.success(new ProposalDefaultLanguagePerOrg());
      } else {
        return $decode.failure(new UnknownGroup(), "curve_kind_decoder");
      }
    },
  );
}

export function instant_metric_decoder() {
  return $decode.field(
    "value",
    $decode.float,
    (value) => {
      return $decode.field(
        "label",
        $decode.string,
        (label) => {
          return $decrypt.optional_field(
            "group_label",
            $decode.string,
            (group_label) => {
              return $decode.success(
                new InstantMetric(value, label, group_label),
              );
            },
          );
        },
      );
    },
  );
}

export function metric_group_decoder() {
  return $decode.field(
    "data",
    $decode.list(instant_metric_decoder()),
    (data) => {
      return $decode.field(
        "kind",
        metric_group_kind_decoder(),
        (kind) => { return $decode.success(new MetricGroup(kind, data)); },
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "id",
    $decrypt.uuid(),
    (id) => {
      return $decode.field(
        "value",
        $decode.float,
        (value) => {
          return $decode.field(
            "curve_id",
            $decrypt.uuid(),
            (curve_id) => {
              return $decode.field(
                "created_at",
                $decrypt.timestamp(),
                (created_at) => {
                  return $decode.success(
                    new Metric(id, value, curve_id, created_at),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function curve_kind_decoder() {
  return $decode.then$(
    $decode.string,
    (kind) => {
      if (kind === "question_created") {
        return $decode.success(new QuestionCreated());
      } else if (kind === "proposal_created") {
        return $decode.success(new ProposalCreated());
      } else if (kind === "answer_created") {
        return $decode.success(new AnswerCreated());
      } else if (kind === "confidence_score") {
        return $decode.success(new ConfidenceScore());
      } else if (kind === "answer_validated") {
        return $decode.success(new AnswerValidated());
      } else {
        return $decode.failure(new Unknown(), "curve_kind_decoder");
      }
    },
  );
}

function data_decoder() {
  return $decode.field(
    "name",
    $decode.string,
    (name) => {
      return $decode.field(
        "period",
        $duration_.unit_decoder(),
        (period) => {
          return $decode.field(
            "kind",
            curve_kind_decoder(),
            (kind) => {
              return $decode.success(new CurveData(name, period, kind));
            },
          );
        },
      );
    },
  );
}

export function curve_decoder() {
  return $decode.field(
    "id",
    $decrypt.uuid(),
    (id) => {
      return $decode.field(
        "created_at",
        $decrypt.timestamp(),
        (created_at) => {
          return $decode.field(
            "org_id",
            $decode.string,
            (org_id) => {
              return $decode.field(
                "data",
                $decrypt.json(data_decoder()),
                (data) => {
                  return $decode.success(
                    new Curve(id, org_id, created_at, data),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function metrics_curve_decoder() {
  return $decode.field(
    "curve",
    curve_decoder(),
    (curve) => {
      return $decode.field(
        "metrics",
        $decode.list(decoder()),
        (metrics) => {
          return $decode.success(new MetricsCurve(curve, metrics));
        },
      );
    },
  );
}

export function encode_kind(kind) {
  if (kind instanceof QuestionCreated) {
    return "question_created";
  } else if (kind instanceof AnswerCreated) {
    return "answer_created";
  } else if (kind instanceof AnswerValidated) {
    return "answer_validated";
  } else if (kind instanceof ProposalCreated) {
    return "proposal_created";
  } else if (kind instanceof ConfidenceScore) {
    return "confidence_score";
  } else {
    return "unknown";
  }
}

export function encode_metric_group_kind(kind) {
  if (kind instanceof TranslationPerLangCreated) {
    return "translation_lang_created";
  } else if (kind instanceof ProposalLanguagePerOrg) {
    return "proposal_language_org";
  } else if (kind instanceof ProposalDefaultLanguagePerOrg) {
    return "translation_default_lang_created";
  } else {
    return "unknown";
  }
}

export function encode_instant_metrics(instant) {
  return $json.object(
    toList([
      ["value", $json.float(instant.value)],
      ["label", $json.string(instant.label)],
      ["group_label", $json.nullable(instant.group_label, $json.string)],
    ]),
  );
}

export function encode_metrics_group(group) {
  return $json.object(
    toList([
      ["kind", $json.string(encode_metric_group_kind(group.kind))],
      ["data", $json.array(group.data, encode_instant_metrics)],
    ]),
  );
}

export function encode(metric) {
  return $json.object(
    toList([
      ["id", $json.string(metric.id)],
      ["value", $json.float(metric.value)],
      ["curve_id", $json.string(metric.curve_id)],
      ["created_at", $timestamp_.encode(metric.created_at)],
    ]),
  );
}

export function encode_curve_data(data) {
  return $json.object(
    toList([
      ["name", $json.string(data.name)],
      ["kind", $json.string(encode_kind(data.kind))],
      ["period", $duration_.encode_unit(data.period)],
    ]),
  );
}

export function encode_curve(curve) {
  return $json.object(
    toList([
      ["id", $json.string(curve.id)],
      ["data", encode_curve_data(curve.data)],
      ["org_id", $json.string(curve.org_id)],
      ["created_at", $timestamp_.encode(curve.created_at)],
    ]),
  );
}

export function encode_metrics_curve(metric_curve) {
  return $json.object(
    toList([
      ["curve", encode_curve(metric_curve.curve)],
      ["metrics", $json.array(metric_curve.metrics, encode)],
    ]),
  );
}

export function last_week() {
  let remove_one_week = $duration_.weeks(-1);
  let _pipe = $timestamp.system_time();
  return $timestamp.add(_pipe, remove_one_week);
}

/**
 * check if `check` timestamp is contain between `start` and `end` or equal to `start`
 * 
 * @ignore
 */
function contain(start, end, check) {
  let start_in = $timestamp.compare(start, check);
  return ((start_in instanceof $order.Eq) || (start_in instanceof $order.Lt)) && ($timestamp.compare(
    check,
    end,
  ) instanceof $order.Lt);
}

function get_previous_bound(timestamp, period) {
  let bound_gap = $duration_.unit_to_seconds(period);
  let seconds = $timestamp_.to_seconds(timestamp);
  return $timestamp.from_unix_seconds(
    seconds - (remainderInt(seconds, bound_gap)),
  );
}

export function transform_curve(curve, metrics, start) {
  return $bool.guard(
    $list.length(metrics) <= 1,
    metrics,
    () => {
      let _block;
      let _pipe = metrics;
      _block = $list.sort(
        _pipe,
        (e1, e2) => { return $timestamp.compare(e1.created_at, e2.created_at); },
      );
      let sorted = _block;
      let $ = $list.first(sorted);
      let $1 = $list.last(sorted);
      if ($ instanceof Ok && $1 instanceof Ok) {
        let first = $[0];
        let last = $1[0];
        let bound_gap = $duration_.unit_to_seconds(curve.data.period);
        let start$1 = $option.unwrap(start, first.created_at);
        let gap = $timestamp_.to_seconds(last.created_at) - $timestamp_.to_seconds(
          start$1,
        );
        let _block$1;
        let _pipe$1 = $int.divide(
          gap,
          $duration_.unit_to_seconds(curve.data.period),
        );
        _block$1 = $result.map(
          _pipe$1,
          (_capture) => { return $int.add(_capture, 1); },
        );
        let $2 = _block$1;
        let steps;
        if ($2 instanceof Ok) {
          steps = $2[0];
        } else {
          throw makeError(
            "let_assert",
            FILEPATH,
            "data/metrics",
            222,
            "transform_curve",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $2,
              start: 6242,
              end: 6371,
              pattern_start: 6253,
              pattern_end: 6262
            }
          )
        }
        let _block$2;
        let _pipe$2 = $int.range(0, steps + 1, toList([]), $list.prepend);
        _block$2 = $list.reverse(_pipe$2);
        let steps$1 = _block$2;
        return $list.map(
          steps$1,
          (index) => {
            let _block$3;
            let _pipe$3 = start$1;
            let _pipe$4 = $timestamp.add(
              _pipe$3,
              $duration.seconds(bound_gap * index),
            );
            _block$3 = get_previous_bound(_pipe$4, curve.data.period);
            let start_bound = _block$3;
            let _block$4;
            let _pipe$5 = start$1;
            let _pipe$6 = $timestamp.add(
              _pipe$5,
              $duration.seconds(bound_gap * (index + 1)),
            );
            _block$4 = get_previous_bound(_pipe$6, curve.data.period);
            let end_bound = _block$4;
            let _pipe$7 = metrics;
            let _pipe$8 = $list.filter(
              _pipe$7,
              (m) => { return contain(start_bound, end_bound, m.created_at); },
            );
            let _pipe$9 = $list.last(_pipe$8);
            return $result.lazy_unwrap(
              _pipe$9,
              () => {
                return new Metric($uuid.new$(), 0.0, curve.id, start_bound);
              },
            );
          },
        );
      } else {
        return metrics;
      }
    },
  );
}
